import axios from 'utils/axios';

export const getAllUnits = async ({
    perPage = 10,
    pageNo = 1,
    query = '',
    showDisabled = false,
    tags = [],
    startDate = '',
    endDate = '',
    sortField = '',
    sorting = ''
}) => {
    try {
        const formattedTags = tags.toString();
        const response = await axios.get('units/', {
            params: {
                perPage,
                pageNo,
                query,
                showDisabled,
                tags: formattedTags,
                startDate,
                endDate,
                sortField,
                sorting
            }
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};
